export const wellbeing = {
  main_title: "Well-being",
  happy: "Good",
  neutral: "Neutral",
  sad: "Bad",
  legend_info: "{1} responses ({2} %)",
  calendar_info: "Click on day to see details",
  no_entries: "No entries",
};
